import { Col, Container, Row } from "react-bootstrap";
import PageTitleBar from "../../Components/Site/PageTitleBar";

const RefundShippingPolicy = (props) => {

  return (
    <>

      <PageTitleBar title="Refund & Cancellation Policy" subTitle="Last Updated on 27th August 2025" />

      <section id="privacy-policy" className="section-pad">
        <Container>

          <Row>
            <Col>
              <div className="cms-content">

                <p>Refund and Cancellation Policy for Joyfullminds.com</p>

                <h2>1. General Policy</h2>
                <ul>
                  <li>All payments made for counseling, therapy, coaching, or wellness sessions are non-refundable unless expressly required by applicable law.</li>
                  <li>By booking and paying for a session/package on Joyfullminds.com, you agree to this policy</li>
                </ul>

                <h2>2. Session Booking and Cancellation by User</h2>
                <ul>
                  <li>If you wish to cancel your booking before the scheduled session, no refund will be issued. Please ensure your availability and need for the service before making a payment.</li>
                  <li>If you are unable to attend a scheduled session, you may request to reschedule by giving at least 24 hours notice. Rescheduling is up to the discretion of your assigned professional and subject to availability</li>
                  <li>If you are late, the session will end at the originally scheduled time. Failure to attend the session without prior notice will result in the session being considered completed, and no refund or rescheduling will be provided.</li>
                </ul>

                <h2>3. Session Cancellation by Joyfullminds.com</h2>
                <ul>
                  <li>If a session is canceled by your therapist/counselor or by Joyfullminds.com due to unforeseen circumstances, you will be offered the following options:</li>
                  <li>Full refund for that session</li>
                  <li>Reschedule the session at no additional cost</li>
                </ul>

                <h2>4. Package Validity</h2>
                <ul>
                  <li>All session packages must be utilized within their stated validity period. Unused sessions or time left in an expired package are not eligible for a refund or extension.</li>
                </ul>

                <h2>5. Dissatisfaction with Services</h2>
                <ul>
                  <li>If you are dissatisfied with your assigned professional, you may request a change in therapist/counselor, subject to review. No partial or full refund will be given for dissatisfaction with services after sessions have begun.</li>
                  <li>Refunds are not entertained on claims of general dissatisfaction, post-session feedback, or after the package has expired or been fully utilized.</li>
                </ul>

                <h2>6. How to Request a Refund (In Exceptional Situations)</h2>
                <ul>
                  <li>Any exception, such as double payment or error in transaction, should be reported to munish.kanwar@Joyfullminds.com within 24 hours of payment. These will be considered on a case-by-case basis.</li>
                  <li>Approved refund requests will be processed within 7–10 business days after approval.</li>
                </ul>

                <h2>7. Policy Changes</h2>
                <ul>
                  <li>Joyfullminds.com reserves the right to amend this policy at any time. Continued use of our services constitutes acceptance of any such changes.</li>
                </ul>

              </div>
            </Col>
          </Row>

        </Container>
      </section>

    </>
  );
};

export default RefundShippingPolicy;
